import React from 'react';
import { Button, message, Space } from 'antd';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import './FileCard.less';
import axios from 'axios';
import { archivePersonRoute } from '../../lib/routes/persons';
import moment from 'moment';
import { useForm } from 'antd/es/form/Form';
import UserForm from '../UserForm/UserForm';
import { useParams } from 'react-router-dom';
import { getPersonFullCard } from '../../store/slices/personsSlice/personsSlice';
import usePermissions from '../../lib/utils/usePermissions';
import {
  PERSON_READ_ALLREGIONS,
  PERSON_READ_FULLACCESS,
  PERSON_WRITE,
  PERSON_WRITE_ALLREGIONS,
} from '../../lib/const/permissions';
import FilesList from '../FilesList/FilesList';

interface Props {
  isEditMode: boolean;
  isNewWard?: boolean;
  setIsEditMode: (mode: boolean) => void;
  editPerson: (fields) => void;
  image: any;
  handleNewImage: (file, route) => void;
  isImageLoading: boolean;
}

function FileCard(props: Props) {
  const { setIsEditMode, editPerson, isEditMode, image, handleNewImage, isImageLoading } = props;
  const { personFullCard, personCard } = useAppSelector((state) => state.persons);
  const dispatch = useAppDispatch();
  const { fileId } = useParams();
  const [hasAccess] = usePermissions();
  const isMinAccess = !hasAccess([PERSON_READ_FULLACCESS]);
  const personData = isMinAccess ? personCard : personFullCard;
  const isArchived = personData?.personStatusId === 5;

  const [form] = useForm();

  const initialValues = {
    ...personData,
    ...personData?.education,
    ...personData?.religion,
    ...personData?.health,
    ...personData?.address,
    ...personData?.social,
    ...personData?.official,
    ...personData?.contract,
    endDate: personData?.contract?.endDate ? moment(personData.contract?.endDate) : undefined,
    noMiddleName: !personData?.middleName || personData?.middleName === '',
    religion: personData?.religion?.religion,
    birthDate: personData?.birthDate ? moment(personData.birthDate) : undefined,
    deathDate: personData?.deathDate ? moment(personData.deathDate) : undefined,
    interviewDate: personData?.official?.interviewDate ? moment(personData.official.interviewDate) : undefined,
    trainingDate: personData?.official?.trainingDate ? moment(personData.official.trainingDate) : undefined,
  };

  const handleArchive = () => {
    axios
      .patch(archivePersonRoute(personData?.id))
      .then(() => {
        message.success('Перенесен в архив');
      })
      .then(() => {
        if (fileId) {
          dispatch(getPersonFullCard({ id: Number(fileId) }));
        }
      });
  };

  const renderButtonsTop = () => {
    if (isArchived) return null;
    if (!isEditMode && hasAccess([PERSON_WRITE_ALLREGIONS, PERSON_WRITE])) {
      return (
        <Button type="primary" onClick={() => setIsEditMode(true)}>
          Редактировать
        </Button>
      );
    }
    return null;
  };

  const renderButtonsBottom = () => {
    if (isArchived) return null;
    if (isEditMode) {
      return (
        <Space className="mt20 mb20">
          <Button
            onClick={() => {
              setIsEditMode(false);
              form.resetFields();
            }}
          >
            Отмена
          </Button>
          <Button
            type="primary"
            onClick={() => {
              form
                .validateFields()
                .then(() => {
                  editPerson(form.getFieldsValue());
                })
                .catch((e) => {
                  console.log(e);
                });
            }}
          >
            Сохранить
          </Button>
        </Space>
      );
    }
    return null;
  };

  return (
    <>
      <div className="card ml20 mr20">
        <UserForm
          initialValues={initialValues}
          isEditMode={isEditMode}
          form={form}
          handleArchive={handleArchive}
          image={image}
          handleNewImage={handleNewImage}
          renderButtonsTop={renderButtonsTop}
          isImageLoading={isImageLoading}
        />
        {hasAccess([PERSON_READ_ALLREGIONS, PERSON_READ_FULLACCESS]) && <FilesList />}
        {renderButtonsBottom()}
      </div>
    </>
  );
}

export default FileCard;
